import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhproductstatusDashboard from '../PhproductstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhproductstatusPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhproductstatusDashboard />
    )

}